import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import {io} from "socket.io-client";
import {getMethod} from '../Apis/apis';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';

const ContainerDiv = styled.div`
   padding: 10px;
`
const Ul = styled.ul`
    // display: grid;
    // grid-template-columns: auto auto;
`
const Li = styled.li`
    padding: 5px 0;
    user-select: none;
    ${'' /* margin: 5px; */}
    
    &:last-child {
        margin-bottom: 0;
    }
`
const ResultNum = styled.p`
    font-weight: bolder;
    color: ${props => props.theme.fontColor};
    font-size: 35px;
    letter-spacing: .6px;
    margin-bottom: 0;
    width: 20%;
    text-align: center;
    background-color: ${props => props.theme.secondary};
    border-radius: 10px;
    margin-right: 10px;
    padding: 10px;
`

const TimeResultFlex = styled.div`
    display: flex;
    align-items: center; 
    color: #FFF;

    span {
      background-color: ${props => props.theme.secondary};
      color: #FFF;
      font-size: 25px;
      display: block;
      width: 80%;
      border-radius: 10px;
      text-align: center;
      padding: 17px;
      p {
          margin-bottom: 0;
          text-align: center;
        } 
    } 
`


const DailyResult = () => {
    const [result10,setResult10] = useState("--");
    const [result12,setResult12] = useState("--");
    const [result14,setResult14] = useState("--");
    const [result16,setResult16] = useState("--");
    const [result18,setResult18] = useState("--");
    const [result20,setResult20] = useState("--");
    const [result22,setResult22] = useState("--");
    let currentDate = moment().tz("Asia/Yangon").format("YYYY-MM-DD");
 

    useEffect(()=>{
       const fetch = async () => {
        let res = await getMethod(`/number/filter?date=${currentDate}`);
            if(res){
               if(res.data){
                if(res.data.length > 0){
                  res.data.map(obj => {
                    if(obj.time === "10:00 AM"){
                      setResult10(obj.result);
                    };
  
                    if(obj.time === "12:00 PM"){
                      setResult12(obj.result);
                    };
  
                   if(obj.time === "02:00 PM"){
                     setResult14(obj.result);
                   };
  
                   if(obj.time === "04:00 PM"){
                     setResult16(obj.result);
                   };
  
                   if(obj.time === "06:00 PM"){
                     setResult18(obj.result);
                   };

                   if(obj.time === "08:00 PM"){
                      setResult20(obj.result);
                   };

                   if(obj.time === "10:00 PM"){
                      setResult22(obj.result);
                   };
                  })
                };
               }
            }
       };
       fetch();
    },[]);
    
    useEffect(
      () => {
        const socket = io(`${process.env.REACT_APP_HOST}/live`);
        socket.connect();
        socket.on("result", res => {
            if(res){
              switch(res.time) {
                case "10:00 AM":
                  setResult10(res.result);
                  break;
                case "12:00 PM":
                  setResult12(res.result);
                  break;
                case "02:00 PM":
                  setResult14(res.result);
                  break;
                case "04:00 PM":
                  setResult16(res.result);
                  break;
                case "06:00 PM":
                  setResult18(res.result);
                  break;
                case "08:00 PM":
                  setResult20(res.result);
                  break;
                case "10:00 PM":
                  setResult22(res.result);
                  break;
                default:
                  return;
              };
            }
        });
        return () => {
          socket.disconnect();
        }
      },[]
    );


  return (
    <ContainerDiv>
       <Ul>
          <Li>
            <TimeResultFlex>
                {
                  <ResultNum>{result10}</ResultNum>
                }
                <span>
                  <p>10:00 &nbsp;AM</p>
                </span>
            </TimeResultFlex>
          </Li>
          <Li>
          <TimeResultFlex>
                {
                  <ResultNum>{result12}</ResultNum>
                }
                <span>
                  <p>12:00 &nbsp;PM</p>
                </span>
            </TimeResultFlex>
          </Li>
          <Li>
            <TimeResultFlex>
                {
                  <ResultNum>{result14}</ResultNum>
                }
                <span>
                  <p>02:00 &nbsp;PM</p>
                </span>
            </TimeResultFlex>
          </Li>
          <Li>
            <TimeResultFlex>
                {
                  <ResultNum>{result16}</ResultNum>
                }
                <span>
                  <p>04:00 &nbsp;PM</p>
                </span>
            </TimeResultFlex>
          </Li>
          <Li>
            <TimeResultFlex>
                {
                  <ResultNum>{result18}</ResultNum>
                }
                <span>
                  <p>06:00 &nbsp;PM</p>
                </span>
            </TimeResultFlex>
          </Li>
          <Li>
            <TimeResultFlex>
                {
                  <ResultNum>{result20}</ResultNum>
                }
                <span>
                  <p>08:00 &nbsp;PM</p>
                </span>
            </TimeResultFlex>
          </Li>
          <Li>
            <TimeResultFlex>
                {
                  <ResultNum>{result22}</ResultNum>
                }
                <span>
                  <p>10:00 &nbsp;PM</p>
                </span>
            </TimeResultFlex>
          </Li>
       </Ul>
    </ContainerDiv>
  )
}

export default DailyResult
